import React from 'react';
import { Text } from 'components';
import { Link } from 'react-router-dom';
import { Routes } from 'core/routes.types';
import { MargedButton, MargedTitle } from './OrderError.style';

const OrderConfirmation: React.FunctionComponent = () => {
    return (
        <>
            <MargedTitle text="order_error_title" type="large" />
            <Text text="order_error_content" />
            <Link to={Routes.Payment}>
                <MargedButton fullWidth>
                    <Text text={'retry'} weight="bold" />
                </MargedButton>
            </Link>
        </>
    );
};

export default OrderConfirmation;
